module.exports = __webpack_public_path__ + "static/media/bindark.209f0143.svg";